import React from "react"
import { Link } from "gatsby"
import { Section } from "../../components/Containers"
import { Text, Image } from "../../components/Core"
import { Button } from "../../components/Button"
import Slider from "react-slick"

const LearnMoreCards = ({ post }) => {
  if (!post.hasThisSection) return null

  const settings = {
    className: "center",
    centerMode: true,
    infinite: false,
    centerPadding: "60px",
    slidesToShow: 3,
    speed: 500,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          centerPadding: "170px"
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          centerPadding: "30px"
        }
      }
    ]
  }
  return (
    <Section zeroTopDesktop zeroBottom colorBack className="info-cards">
      <div className="columns info-heading">
        <div className="column is-5"></div>
        <div
          className="column has-text-centered px-40--mobile"
          data-aos-duration="1200"
          data-aos="fade-left">
          <Text as="h3" className="has-text-centered" text={post.heading} />
          <Text useStringReplace text={post.blurb} />
        </div>
        <div className="column is-5"></div>
      </div>

      <div className="columns">
        {/* <div className="column is-2"></div> */}
        <div className="column card-section">
          <Slider {...settings}>
            {post.cards &&
              post.cards.map((card, i) => (
                <div className="card-wrapper" key={i}>
                  <Link to={card.button.href} className="info-card rounded">
                    <Image useAR={false} publicId={card.imageId} />

                    <div className="card-content">
                      <Text
                        as="h4"
                        className="card-heading"
                        text={card.heading}
                      />
                      <Text className="card-p" text={card.blurb} />

                      {card.button.href && card.button.buttonText && (
                        <Button
                          className="info-button"
                          minimal
                          internal
                          href={card.button.href}
                          buttonText={card.button.buttonText}
                        />
                      )}
                    </div>
                  </Link>
                </div>
              ))}
          </Slider>
        </div>
        {/* <div className="column is-2"></div> */}
      </div>
    </Section>
  )
}

export default LearnMoreCards
